import dayjs from 'dayjs';
import { mapLegalForm, reverseMapLegalForm } from 'utils/mapper';
import { getDisplayCompanySizeLabel } from 'utils/helpers';
import { isNil, isEmpty } from 'lodash';

export function mapApiDataToForm(api) {
  if (isNil(api) || isEmpty(api)) return {};

  return {
    name: api.firstName ?? '',
    lastname: api.lastName ?? '',
    profession: api.profession ?? '',
    phone: api.contactPhone ?? '',
    email: api.contactEmail ?? '',
    address: api.address ?? '',
    postalCode: api.postalCode ?? '',
    region: api.region ?? '',
    doy: api.doy ?? '',
    kad: api.kad ?? '',
    secondaryKad: api.secondaryKad ?? '',
    companyPhone: api.companyPhone ?? '',
    website: api.companyWebsite ?? '',
    companyEmail: api.companyEmail ?? '',
    companyName: api.companyName ?? '',
    afm: api.afm ?? '',
    foundingDate: api.foundingDate ? dayjs(api.foundingDate) : null,
    legalForm: mapLegalForm(api.legalForm),
    displayValue: getDisplayCompanySizeLabel(api.size),
  };
}

export function mapFormDataToApi(form) {
  if (!form) return {};

  const mapSize = {
    Μικρή: 'SMALL',
    Μεσαία: 'MEDIUM',
    Μεγάλη: 'LARGE',
  };

  return {
    firstName: form.name ?? null,
    lastName: form.lastname ?? null,
    profession: form.profession ?? null,
    contactPhone: form.phone ?? null,
    contactEmail: form.email ?? null,
    address: form.address ?? null,
    postalCode: form.postalCode ?? null,
    region: form.region ?? null,
    doy: form.doy ?? null,
    kad: form.kad ?? null,
    secondaryKad: form.secondaryKad ?? null,
    companyPhone: form.companyPhone ?? null,
    companyEmail: form.companyEmail ?? null,
    companyWebsite: form.website ?? null,
    companyName: form.companyName ?? null,
    afm: form.afm ?? null,
    foundingDate: form.foundingDate
      ? form.foundingDate.format('YYYY-MM-DD')
      : null,
    legalForm: reverseMapLegalForm(form.legalForm),
    size: mapSize[form.displayValue] ?? null,
  };
}
